<template>
	<div class="flex-grow flex flex-col">
		<BaseHeader
			v-if="isUserAllowedInLevel5or6 || isUserAllowedInLevel2 || isUserAllowedInLevel3"
			title="Dashboard"
			subtitle="Unsere Erklärvideos für einen leichteren Umgang mit IMD-Connect.PRO"
		/>
		<div class="flex flex-grow relative">
			<div class="w-full main">
				<div v-if="isUserAllowedInLevel5or6 || isUserAllowedInLevel2 || isUserAllowedInLevel3">
					<div v-if="!isLoading" class="flex flex-row grid grid-cols-3 gap-10">
						<div @click="storeAndPush(video)" v-for="video in videos" :key="video.id" class="bg-gray-400 rounded py-12 cursor-pointer justify-center">
							<div class="flex justify-center mb-8">
								<div class="w-1/3 relative">
									<img alt="Vue logo" class="rounded-md w-full" src="../../assets/logo_pro.png" />
									<div class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded-md">
										<font-awesome-icon :icon="['fas', 'play-circle']" class="text-gray-800" style="font-size: 40px" />
									</div>
								</div>
							</div>

							<div class="font-bold text-lg">
								{{ video.name }}
							</div>
						</div>
						<router-view />
					</div>

					<LoadingSpinner v-else />
				</div>

				<div class="p-48" v-else>
					<div class="flex flex-col justify-center items-center flex-grow">
						<div class="text-3xl mb-4">
							{{ $t('welcome_to') }}
						</div>
						<img alt="Vue logo" class="w-1/2 mb-48" src="../../assets/logo.svg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import DashboardRepository from '@/api/repositories/DashboardRepository';
import Authentication from '@/mixins/Authentication';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	name: 'Dashboard',
	components: { LoadingSpinner, BaseHeader },
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
			videos: [],
		};
	},
	mounted() {
		this.isLoading = true;
		this.getAllVideos();
	},
	methods: {
		getAllVideos() {
			new DashboardRepository()
				.getAllVideos()
				.then(response => {
					this.videos = response.data.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
				});
		},
		storeAndPush(video) {
			this.$store.commit('setModalTitle', video.name);
			this.$router.push({ name: 'dashboard.show_video', params: { videoId: video.id } });
		},
	},
};
</script>
